export default __webpack_public_path__ + "static/media/houserules_mobile.ed33cc40.png";